import React from 'react';

const Logo = ({ className = '' }) => {
    const handleClick = (e) => {
        e.preventDefault();
        const homeSection = document.getElementById('home');
        if (homeSection) {
            homeSection.scrollIntoView({ behavior: 'smooth' });
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    return (
        <a
            href="#home"
            onClick={handleClick}
            className={`serif text-2xl font-bold tracking-tight cursor-pointer hover:opacity-80 transition-opacity ${className}`}
        >
            RICH.TRAN
        </a>
    );
};

export default Logo;
